import { render, staticRenderFns } from "./changelog.vue?vue&type=template&id=37f960f4&scoped=true&"
import script from "./changelog.vue?vue&type=script&lang=js&"
export * from "./changelog.vue?vue&type=script&lang=js&"
import style0 from "./changelog.vue?vue&type=style&index=0&id=37f960f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f960f4",
  null
  
)

export default component.exports